// Route Configuration Constants
// This file contains all route-related constants and configurations

// Route Paths
export const ROUTE_PATHS = {
  // Public routes
  PUBLIC: {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    NOT_FOUND: '/404'
  },
  
  // Protected routes
  PROTECTED: {
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    CHANGE_PASSWORD: '/change-password',
    SUBSCRIPTION: '/subscription'
  },
  
  // Subscription-protected routes
  SUBSCRIPTION_PROTECTED: {
    SUREBETS: '/surebets',
    SUREBET_DETAIL: '/surebets/:id',
    FILTERS: '/filters'
  },
  
  // Admin routes
  ADMIN: {
    DASHBOARD: '/admin',
    DASHBOARD_ALL: '/admin/*'
  },
  
  // Super admin routes
  SUPER_ADMIN: {
    DASHBOARD: '/super-admin',
    DASHBOARD_ALL: '/super-admin/*'
  }
};

// Route Names (for display purposes)
export const ROUTE_NAMES = {
  [ROUTE_PATHS.PUBLIC.HOME]: 'Начало',
  [ROUTE_PATHS.PUBLIC.LOGIN]: 'Вход',
  [ROUTE_PATHS.PUBLIC.REGISTER]: 'Регистрация',
  [ROUTE_PATHS.PUBLIC.NOT_FOUND]: 'Страницата не е намерена',
  
  [ROUTE_PATHS.PROTECTED.DASHBOARD]: 'Табло',
  [ROUTE_PATHS.PROTECTED.PROFILE]: 'Профил',
  [ROUTE_PATHS.PROTECTED.CHANGE_PASSWORD]: 'Смяна на парола',
  [ROUTE_PATHS.PROTECTED.SUBSCRIPTION]: 'Абонамент',
  
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS]: 'Арбитражни възможности',
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBET_DETAIL]: 'Детайли за арбитраж',
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.FILTERS]: 'Филтри',
  
  [ROUTE_PATHS.ADMIN.DASHBOARD]: 'Админ панел',
  [ROUTE_PATHS.SUPER_ADMIN.DASHBOARD]: 'Супер админ панел'
};

// Route Icons (for navigation)
export const ROUTE_ICONS = {
  [ROUTE_PATHS.PUBLIC.HOME]: 'home',
  [ROUTE_PATHS.PUBLIC.LOGIN]: 'log-in',
  [ROUTE_PATHS.PUBLIC.REGISTER]: 'user-plus',
  [ROUTE_PATHS.PUBLIC.NOT_FOUND]: 'alert-circle',
  
  [ROUTE_PATHS.PROTECTED.DASHBOARD]: 'dashboard',
  [ROUTE_PATHS.PROTECTED.PROFILE]: 'user',
  [ROUTE_PATHS.PROTECTED.CHANGE_PASSWORD]: 'key',
  [ROUTE_PATHS.PROTECTED.SUBSCRIPTION]: 'credit-card',
  
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS]: 'trending-up',
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBET_DETAIL]: 'bar-chart',
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.FILTERS]: 'filter',
  
  [ROUTE_PATHS.ADMIN.DASHBOARD]: 'settings',
  [ROUTE_PATHS.SUPER_ADMIN.DASHBOARD]: 'shield'
};

// Route Categories
export const ROUTE_CATEGORIES = {
  PUBLIC: 'public',
  PROTECTED: 'protected',
  SUBSCRIPTION_PROTECTED: 'subscription_protected',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin'
};

// Route Access Levels
export const ROUTE_ACCESS_LEVELS = {
  PUBLIC: 0,
  AUTHENTICATED: 1,
  SUBSCRIBED: 2,
  ADMIN: 3,
  SUPER_ADMIN: 4
};

// Route Metadata
export const ROUTE_METADATA = {
  [ROUTE_PATHS.PUBLIC.HOME]: {
    title: 'ArbiWin - Арбитражни възможности',
    description: 'Анализ на арбитражни възможности в спортни пазари.',
    keywords: 'арбитраж, залози, печалба, букмейкъри',
    category: ROUTE_CATEGORIES.PUBLIC,
    accessLevel: ROUTE_ACCESS_LEVELS.PUBLIC,
    requiresAuth: false,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.PUBLIC.LOGIN]: {
    title: 'Вход - ArbiWin',
    description: 'Влезте в акаунта си за достъп до арбитражните възможности',
    keywords: 'вход, акаунт, аутентификация',
    category: ROUTE_CATEGORIES.PUBLIC,
    accessLevel: ROUTE_ACCESS_LEVELS.PUBLIC,
    requiresAuth: false,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.PUBLIC.REGISTER]: {
    title: 'Регистрация - ArbiWin',
    description: 'Създайте акаунт за достъп до арбитражните възможности',
    keywords: 'регистрация, акаунт, създаване',
    category: ROUTE_CATEGORIES.PUBLIC,
    accessLevel: ROUTE_ACCESS_LEVELS.PUBLIC,
    requiresAuth: false,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.PUBLIC.NOT_FOUND]: {
    title: 'Страницата не е намерена - ArbiWin',
    description: 'Страницата, която търсите, не съществува',
    keywords: '404, грешка, страница не намерена',
    category: ROUTE_CATEGORIES.PUBLIC,
    accessLevel: ROUTE_ACCESS_LEVELS.PUBLIC,
    requiresAuth: false,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: false,
    showInBreadcrumb: false
  },
  
  [ROUTE_PATHS.PROTECTED.DASHBOARD]: {
    title: 'Табло - ArbiWin',
    description: 'Вашето табло с арбитражни възможности',
    keywords: 'табло, арбитраж, възможности',
    category: ROUTE_CATEGORIES.PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.AUTHENTICATED,
    requiresAuth: true,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.PROTECTED.PROFILE]: {
    title: 'Профил - ArbiWin',
    description: 'Управление на профила и настройки',
    keywords: 'профил, настройки, управление',
    category: ROUTE_CATEGORIES.PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.AUTHENTICATED,
    requiresAuth: true,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.PROTECTED.CHANGE_PASSWORD]: {
    title: 'Смяна на парола - ArbiWin',
    description: 'Сменете паролата на акаунта си',
    keywords: 'парола, смяна, сигурност',
    category: ROUTE_CATEGORIES.PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.AUTHENTICATED,
    requiresAuth: true,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: false,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.PROTECTED.SUBSCRIPTION]: {
    title: 'Абонамент - ArbiWin',
    description: 'Управление на абонамента',
    keywords: 'абонамент, управление, плащане',
    category: ROUTE_CATEGORIES.PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.AUTHENTICATED,
    requiresAuth: true,
    requiresSubscription: false,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS]: {
    title: 'Арбитражни възможности - ArbiWin',
    description: 'Арбитражни възможности и инструменти за пазарен анализ.',
    keywords: 'арбитраж, възможности, залози',
    category: ROUTE_CATEGORIES.SUBSCRIPTION_PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.SUBSCRIBED,
    requiresAuth: true,
    requiresSubscription: true,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBET_DETAIL]: {
    title: 'Детайли за арбитраж - ArbiWin',
    description: 'Детайлна информация за арбитражна възможност',
    keywords: 'арбитраж, детайли, информация',
    category: ROUTE_CATEGORIES.SUBSCRIPTION_PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.SUBSCRIBED,
    requiresAuth: true,
    requiresSubscription: true,
    requiredRole: null,
    showInNavigation: false,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.FILTERS]: {
    title: 'Филтри - ArbiWin',
    description: 'Филтриране на арбитражни възможности',
    keywords: 'филтри, търсене, опции',
    category: ROUTE_CATEGORIES.SUBSCRIPTION_PROTECTED,
    accessLevel: ROUTE_ACCESS_LEVELS.SUBSCRIBED,
    requiresAuth: true,
    requiresSubscription: true,
    requiredRole: null,
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.ADMIN.DASHBOARD]: {
    title: 'Админ панел - ArbiWin',
    description: 'Административен панел за управление',
    keywords: 'админ, управление, панел',
    category: ROUTE_CATEGORIES.ADMIN,
    accessLevel: ROUTE_ACCESS_LEVELS.ADMIN,
    requiresAuth: true,
    requiresSubscription: false,
    requiredRole: 'admin',
    showInNavigation: true,
    showInBreadcrumb: true
  },
  
  [ROUTE_PATHS.SUPER_ADMIN.DASHBOARD]: {
    title: 'Супер админ панел - ArbiWin',
    description: 'Супер административен панел за управление',
    keywords: 'супер админ, управление, панел',
    category: ROUTE_CATEGORIES.SUPER_ADMIN,
    accessLevel: ROUTE_ACCESS_LEVELS.SUPER_ADMIN,
    requiresAuth: true,
    requiresSubscription: false,
    requiredRole: 'super_admin',
    showInNavigation: true,
    showInBreadcrumb: true
  }
};

// Route Groups (for navigation organization)
export const ROUTE_GROUPS = {
  MAIN: {
    name: 'Основни',
    routes: [
      ROUTE_PATHS.PUBLIC.HOME,
      ROUTE_PATHS.PROTECTED.DASHBOARD,
      ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS
    ]
  },
  
  AUTH: {
    name: 'Аутентификация',
    routes: [
      ROUTE_PATHS.PUBLIC.LOGIN,
      ROUTE_PATHS.PUBLIC.REGISTER
    ]
  },
  
  USER: {
    name: 'Потребител',
    routes: [
      ROUTE_PATHS.PROTECTED.PROFILE,
      ROUTE_PATHS.PROTECTED.CHANGE_PASSWORD,
      ROUTE_PATHS.PROTECTED.SUBSCRIPTION
    ]
  },
  
  SUREBETS: {
    name: 'Арбитраж',
    routes: [
      ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS,
      ROUTE_PATHS.SUBSCRIPTION_PROTECTED.FILTERS
    ]
  },
  
  ADMIN: {
    name: 'Администрация',
    routes: [
      ROUTE_PATHS.ADMIN.DASHBOARD,
      ROUTE_PATHS.SUPER_ADMIN.DASHBOARD
    ]
  }
};

// Route Permissions
export const ROUTE_PERMISSIONS = {
  [ROUTE_PATHS.PUBLIC.HOME]: ['public'],
  [ROUTE_PATHS.PUBLIC.LOGIN]: ['public'],
  [ROUTE_PATHS.PUBLIC.REGISTER]: ['public'],
  [ROUTE_PATHS.PUBLIC.NOT_FOUND]: ['public'],
  
  [ROUTE_PATHS.PROTECTED.DASHBOARD]: ['user', 'admin', 'super_admin'],
  [ROUTE_PATHS.PROTECTED.PROFILE]: ['user', 'admin', 'super_admin'],
  [ROUTE_PATHS.PROTECTED.CHANGE_PASSWORD]: ['user', 'admin', 'super_admin'],
  [ROUTE_PATHS.PROTECTED.SUBSCRIPTION]: ['user', 'admin', 'super_admin'],
  
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS]: ['user', 'admin', 'super_admin'],
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBET_DETAIL]: ['user', 'admin', 'super_admin'],
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.FILTERS]: ['user', 'admin', 'super_admin'],
  
  [ROUTE_PATHS.ADMIN.DASHBOARD]: ['admin', 'super_admin'],
  [ROUTE_PATHS.SUPER_ADMIN.DASHBOARD]: ['super_admin']
};

// Route Redirects
export const ROUTE_REDIRECTS = {
  // Redirect authenticated users away from auth pages
  [ROUTE_PATHS.PUBLIC.LOGIN]: ROUTE_PATHS.PROTECTED.DASHBOARD,
  [ROUTE_PATHS.PUBLIC.REGISTER]: ROUTE_PATHS.PROTECTED.DASHBOARD,
  
  // Redirect unauthenticated users to login
  [ROUTE_PATHS.PROTECTED.DASHBOARD]: ROUTE_PATHS.PUBLIC.LOGIN,
  [ROUTE_PATHS.PROTECTED.PROFILE]: ROUTE_PATHS.PUBLIC.LOGIN,
  [ROUTE_PATHS.PROTECTED.CHANGE_PASSWORD]: ROUTE_PATHS.PUBLIC.LOGIN,
  [ROUTE_PATHS.PROTECTED.SUBSCRIPTION]: ROUTE_PATHS.PUBLIC.LOGIN,
  
  // Redirect users without subscription to subscription page
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBETS]: ROUTE_PATHS.PROTECTED.SUBSCRIPTION,
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.SUREBET_DETAIL]: ROUTE_PATHS.PROTECTED.SUBSCRIPTION,
  [ROUTE_PATHS.SUBSCRIPTION_PROTECTED.FILTERS]: ROUTE_PATHS.PROTECTED.SUBSCRIPTION,
  
  // Redirect non-admin users away from admin pages
  [ROUTE_PATHS.ADMIN.DASHBOARD]: ROUTE_PATHS.PROTECTED.DASHBOARD,
  [ROUTE_PATHS.SUPER_ADMIN.DASHBOARD]: ROUTE_PATHS.PROTECTED.DASHBOARD
};

// Route Validation Rules
export const ROUTE_VALIDATION_RULES = {
  // Path validation
  path: {
    required: true,
    pattern: /^\/[a-zA-Z0-9\-_\/:]*$/,
    message: 'Path must start with / and contain only valid characters'
  },
  
  // Title validation
  title: {
    required: true,
    minLength: 1,
    maxLength: 100,
    message: 'Title must be between 1 and 100 characters'
  },
  
  // Description validation
  description: {
    required: true,
    minLength: 10,
    maxLength: 200,
    message: 'Description must be between 10 and 200 characters'
  },
  
  // Keywords validation
  keywords: {
    required: true,
    minLength: 5,
    maxLength: 200,
    message: 'Keywords must be between 5 and 200 characters'
  }
};

// Route Error Messages
export const ROUTE_ERROR_MESSAGES = {
  NOT_FOUND: 'Страницата не е намерена',
  ACCESS_DENIED: 'Нямате достъп до тази страница',
  AUTHENTICATION_REQUIRED: 'Необходима е аутентификация',
  SUBSCRIPTION_REQUIRED: 'Необходим е активен абонамент',
  INSUFFICIENT_PERMISSIONS: 'Недостатъчни права за достъп',
  ROUTE_NOT_CONFIGURED: 'Маршрутът не е конфигуриран',
  INVALID_ROUTE: 'Невалиден маршрут',
  REDIRECT_FAILED: 'Пренасочването неуспешно'
};

// Route Success Messages
export const ROUTE_SUCCESS_MESSAGES = {
  NAVIGATION_SUCCESS: 'Успешно навигация',
  REDIRECT_SUCCESS: 'Успешно пренасочване',
  ROUTE_LOADED: 'Страницата е заредена успешно',
  PERMISSION_GRANTED: 'Правата са предоставени'
};

// Route Loading States
export const ROUTE_LOADING_STATES = {
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
  REDIRECTING: 'redirecting'
};

// Route Cache Configuration
export const ROUTE_CACHE_CONFIG = {
  ENABLED: true,
  MAX_AGE: 300000, // 5 minutes
  MAX_SIZE: 50, // Maximum number of cached routes
  CACHE_STRATEGY: 'LRU' // Least Recently Used
};

// Route Analytics Configuration
export const ROUTE_ANALYTICS_CONFIG = {
  ENABLED: true,
  TRACK_PAGE_VIEWS: true,
  TRACK_NAVIGATION_EVENTS: true,
  TRACK_ERRORS: true,
  TRACK_PERFORMANCE: true
};

// Default exports
export default {
  ROUTE_PATHS,
  ROUTE_NAMES,
  ROUTE_ICONS,
  ROUTE_CATEGORIES,
  ROUTE_ACCESS_LEVELS,
  ROUTE_METADATA,
  ROUTE_GROUPS,
  ROUTE_PERMISSIONS,
  ROUTE_REDIRECTS,
  ROUTE_VALIDATION_RULES,
  ROUTE_ERROR_MESSAGES,
  ROUTE_SUCCESS_MESSAGES,
  ROUTE_LOADING_STATES,
  ROUTE_CACHE_CONFIG,
  ROUTE_ANALYTICS_CONFIG
};
